// Pro API - Project Operations
import { request } from "../base";
import type { Project, ProjectPhoto } from "./types";

export const projectsApi = {
	async list(proId: string, params?: Record<string, string>) {
		const query = params ? `?${new URLSearchParams(params).toString()}` : "";
		return request<Project[]>(`/api/pro/${proId}/projects${query}`);
	},

	async get(proId: string, projectId: string) {
		return request<Project & { photos: ProjectPhoto[] }>(
			`/api/pro/${proId}/projects/${projectId}`,
		);
	},

	async create(proId: string, data: Partial<Project>) {
		return request<Project>(`/api/pro/${proId}/projects`, {
			method: "POST",
			body: data,
		});
	},

	async update(proId: string, projectId: string, data: Partial<Project>) {
		return request<Project>(`/api/pro/${proId}/projects/${projectId}`, {
			method: "PUT",
			body: data,
		});
	},

	async delete(proId: string, projectId: string) {
		return request(`/api/pro/${proId}/projects/${projectId}`, {
			method: "DELETE",
		});
	},

	async publish(proId: string, projectId: string) {
		return request<Project>(
			`/api/pro/${proId}/projects/${projectId}/publish`,
			{
				method: "POST",
			},
		);
	},

	async archive(proId: string, projectId: string) {
		return request<Project>(
			`/api/pro/${proId}/projects/${projectId}/archive`,
			{
				method: "POST",
			},
		);
	},

	async unarchive(proId: string, projectId: string) {
		return request<Project>(
			`/api/pro/${proId}/projects/${projectId}/unarchive`,
			{
				method: "POST",
			},
		);
	},
};
